module.exports = __webpack_public_path__ + "img/ico-coach-color.b557e233.svg";